import { Component } from '@angular/core';
import { convertToISO } from 'app/core/shared/helper/date.helper';
import { isFormChange, onTypeChange } from 'app/core/shared/helper/equipment-registration.helper';
import { FormComponent } from 'app/modules/equipment-registration/component/form-component/form.component';
import { module } from 'app/modules/equipment-registration/equipment-registration.module';
import { Valve } from 'app/modules/equipment-registration/model/valve.model';
import { EquipRegistrationServices } from 'app/modules/equipment-registration/services/equipment-registration.service';

@Component({
  selector: 'app-crown-valve',
  templateUrl: './crown-valve.component.html',
  standalone: true,
  imports: [
    ...module,
    FormComponent
  ],
  styleUrls: ['./crown-valve.component.scss']
})
export class CrownValveComponent {
  public equipmentRegistration$ = this.equipmentServices.equipmentRegistration$
  public cvForm: Valve = new Valve();
  public tempCvForm: Valve = new Valve()

  public isReplace: boolean = true;
  public wellStringId: string;
  public disabledToggle: boolean = true;

  constructor(
    private equipmentServices: EquipRegistrationServices
  ) { }

  ngOnInit() {
    this.initializeCvForm()

    this.equipmentRegistration$.subscribe(wellEquipment => {
      if (!wellEquipment) return '';

      this.wellStringId = wellEquipment.wellStringId

      if(wellEquipment?.cValve){
        this.cvForm = new Valve(wellEquipment?.cValve);
      } else {
        this.initializeCvForm()
      }

      this.handleFormValue()
      this.isReplace = !wellEquipment?.cValve;
      this.disabledToggle = !wellEquipment?.cValve;
    })
  }

  private initializeCvForm(): void {
    this.cvForm.reset()
  }

  private handleFormValue() {
    if (!this.cvForm.mdSceValveTypeId) {
      this.setSceValveTypeId()
    }

    if (!this.cvForm.sceXmasTreeId) {
      this.setXmasTreeId()
    }

    // this.cvForm.type = this.cvForm.isActuated ? 'pneumatic' : 'manual'
    this.tempCvForm = new Valve(this.cvForm)
  }

  private setSceValveTypeId() {
    this.equipmentServices.getSceValveTypeId('CV').subscribe(id => {
      this.cvForm.mdSceValveTypeId = this.tempCvForm.mdSceValveTypeId = id
    })
  }

  private setXmasTreeId() {
    this.equipmentServices.getSceXmasTreeByStringId(this.wellStringId).subscribe(res => {
      if (res.data) {
        this.cvForm.sceXmasTreeId = this.tempCvForm.sceXmasTreeId = res.data.id
      }
    })
  }

  disabledSave(): boolean {
    return !this.cvForm.mdSceValveTypeId || !this.cvForm.sceXmasTreeId || isFormChange(this.cvForm, this.tempCvForm)
  }

  save() {
    // if(this.cvForm?.type != this.tempCvForm?.type){
      onTypeChange(this.cvForm)
    // }
    
    const operation = this.isReplace ?
      this.equipmentServices.addSceValve(this.cvForm) :
      this.equipmentServices.updateSceValve(this.cvForm);

    operation.subscribe((res) => {
      if (res) {
        this.equipmentServices.getEquipmentRegistration(this.wellStringId).subscribe();
      }
    });
  }

}
